import { render, staticRenderFns } from "./new-contract-form.vue?vue&type=template&id=135699c6&"
import script from "./new-contract-form.vue?vue&type=script&lang=js&"
export * from "./new-contract-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports